/* Product form */
customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer")) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        }

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(e) {
        e.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        let c = fetchConfig("javascript");
        c.headers["X-Requested-With"] = "XMLHttpRequest";
        delete c.headers["Content-Type"];

        let f = new FormData(this.form);

        if (this.cart) {
          f.append(
            "sections",
            this.cart.getSectionsToRender().map((s) => s.id)
          );
          f.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        c.body = f;

        fetch(routes.cart_add_url, c)
          .then((r) => r.json())
          .then((r) => {
            if (r.status) {
              this.handleErrorMessage(r.description);
              const event = new CustomEvent('cart:error', {
                detail: {
                  status: r.status,
                  message: r.message,
                  description: r.description
                }
              });
              document.dispatchEvent(event);
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: f.get('id'),
                  message: r.message,
                  errors: r.errors || r.description
                });
              }
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: f.get('id'),
                cartData: r
              });
            }

            if (this.cart) {
              this.cart.renderContents(r);
            } else {
              // Fallback to fetch cart.js and update header bubble
              fetch('/cart.js')
                .then((res) => res.json())
                .then((cart) => {
                  const bubbles = document.querySelectorAll('#cart-icon-bubble, #mobile-cart-icon-bubble');
                  bubbles.forEach((bubble) => {
                    let countBubble = bubble.querySelector('.cart-count-bubble');
                    if (cart.item_count > 0) {
                      if (!countBubble) {
                        countBubble = document.createElement('div');
                        countBubble.className = 'cart-count-bubble';
                        bubble.appendChild(countBubble);
                      }
                      countBubble.innerHTML = `<span aria-hidden="true">(${cart.item_count})</span><span class="visually-hidden">${cart.item_count} items</span>`;
                    } else {
                      if (countBubble) countBubble.remove();
                    }
                  });
                });
            }
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(e = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !e);
        if (e) this.errorMessage.textContent = e;
      }
    }
  );

/* Variant gallery sync + strict thumbnail filtering */
(function () {
  /* product-form.js is included globally. Keep gallery setup idempotent if a
   * section or third-party integration accidentally requests it again. */
  if (window.__gamzoVariantGalleryInitialized) return;
  window.__gamzoVariantGalleryInitialized = true;

  function safeEscape(value) {
    const v = (value ?? "").toString();
    if (window.CSS && typeof window.CSS.escape === "function") return CSS.escape(v);
    return v.replace(/["\\]/g, "\\$&");
  }

  function n(s) {
    return (s || "")
      .toString()
      .toLowerCase()
      .replace(/\b(\d+)\s*[_+ -]\s*(\d+)\s*[-_ ]*seater\b/g, "$1+$2 seater")
      .replace(/\s*\+\s*/g, "+")
      .replace(/[-_]+/g, " ")
      .replace(/\b(left|right)handfacing\b/g, "$1 hand facing")
      .replace(/\b(left|right)facing\b/g, "$1 facing")
      .replace(/\b(left|right)hand\b/g, "$1 hand")
      .replace(/\b([lu])shape\b/g, "$1 shape")
      .replace(/\b(\d+)seater\b/g, "$1 seater")
      .replace(/\bfootsool\b/g, "footstool")
      .replace(/\barm\s+chair\b/g, "armchair")
      .replace(/\s+/g, " ")
      .trim();
  }

  function gvRadio(name, root) {
    const sel = `input[type="radio"][name="${safeEscape(name)}"]:checked`;
    const el = (root || document).querySelector(sel);
    return el ? el.value : "";
  }

  function gvSelect(name, root) {
    const sel = `select[name="${safeEscape(name)}"]`;
    const scope = root || document;
    const el = scope.querySelector(sel) || Array.from(scope.querySelectorAll("select")).find((select) => {
      const selectName = n((select.getAttribute("name") || "").replace(/^options\[/i, "").replace(/\]$/, ""));
      return selectName === n(name);
    });
    return el ? el.value : "";
  }

  function getOpt(names, root) {
    for (const k of names) {
      const r = gvRadio(k, root);
      if (r) return r;
    }
    for (const k of names) {
      const s = gvSelect(k, root);
      if (s) return s;
    }
    return "";
  }

  /*
   * Product media is mapped in two ways in Shopify: some images use Alt text,
   * while older uploads use the original file name.  Keep both sources so a
   * value such as "Chocolate Brown 3+2 Seater" can match either
   * `Chocolate Brown 3+2 Seater` (alt) or `ChocolateBrown-3_2Seater_4` (name).
   */
  function imageOf(slide) {
    return slide ? slide.querySelector("img") : null;
  }

  function altOf(slide) {
    const image = imageOf(slide);
    return image ? n(image.getAttribute("alt")) : "";
  }

  function srcOf(slide) {
    const image = imageOf(slide);
    if (!image) return "";
    return image.currentSrc || image.getAttribute("src") || image.getAttribute("data-src") || "";
  }

  function filenameOf(slide) {
    const src = srcOf(slide);
    if (!src) return "";

    let filename = src.split("?")[0].split("/").pop() || "";
    try { filename = decodeURIComponent(filename); } catch (e) {}

    filename = filename
      .replace(/\.[a-z0-9]+$/i, "")
      .replace(/_(?:small|medium|large|grande|pico|icon|thumb|master|\d+x(?:\d+)?)(?:_crop_[a-z]+)?$/i, "")
      .replace(/_[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}$/i, "")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/(\d)Seater/gi, "$1 Seater")
      .replace(/\b(\d+)\s*[_+-]\s*(\d+)\s*[-_ ]*Seater\b/gi, "$1+$2 Seater")
      .replace(/[-_]+/g, " ")
      .replace(/\s+\d+$/, "")
      .replace(/\s+/g, " ")
      .trim();

    return n(filename);
  }

  function metadataOf(slide) {
    return [altOf(slide), filenameOf(slide)].filter(Boolean);
  }

  function mediaIdOf(slide) {
    if (!slide) return "";
    const raw = slide.getAttribute("data-media-id") || slide.getAttribute("data-target") || slide.id || "";
    const match = raw.match(/(?:^|-)\d{6,}$/);
    return match ? match[0].replace(/^-/, "") : raw;
  }

  function imageIndexOf(slide) {
    const name = filenameOf(slide);
    const match = name.match(/(?:^|\s)(\d+)$/);
    return match ? Number(match[1]) : 0;
  }

  function isGenericAlt(value) {
    const a = n(value);
    return !a || /^(product|product image|image|sofa|chair|footstool|swivel)$/.test(a);
  }

  function isSwatchImage(slide) {
    return Boolean(slide && slide.closest(".variant-swatch-label, .product-form__input") && !slide.closest(".product__media-wrapper"));
  }

  function getMainSlides(root) {
    return Array.from((root || document).querySelectorAll(".product__media-list .product__media-item"));
  }

  function getThumbSlides(root) {
    return Array.from((root || document).querySelectorAll(".thumbnail-list .thumbnail-list__item"));
  }

  function show(element, visible) {
    if (!element) return;
    if (visible) {
      element.style.removeProperty("display");
      element.removeAttribute("data-gallery-filtered-out");
    } else {
      /* Swiper/theme CSS can restore slides with display rules; keep the
       * variant filter authoritative until the next selection is evaluated. */
      element.style.setProperty("display", "none", "important");
      element.setAttribute("data-gallery-filtered-out", "true");
    }
    element.toggleAttribute("hidden", !visible);
    element.setAttribute("aria-hidden", visible ? "false" : "true");
  }

  function lockGallery(root) {
    const viewer = (root || document).querySelector(".main_product_img, [id^='GalleryViewer']");
    if (viewer) {
      const h = viewer.offsetHeight;
      if (h > 150) {
        viewer.style.minHeight = h + "px";
      }
      viewer.classList.add("gallery-updating");
    }
  }

  function unlockGallery(root) {
    const gallery = (root || document).querySelector(".product__media-wrapper, media-gallery");
    if (gallery) gallery.setAttribute("data-synced", "true");
    const viewer = (root || document).querySelector(".main_product_img, [id^='GalleryViewer']");
    if (viewer) {
      viewer.classList.remove("gallery-updating");
      setTimeout(() => {
        if (viewer) viewer.style.minHeight = "";
      }, 150);
    }
  }

  function typeMatcher(typeStr) {
    const t = n(typeStr);
    if (!t) return null;

    const hasFootstool = /\b(footstool|footsool|stool|pouffe|ottoman)\b/i.test(t);
    const hasSwivel = /\bswivel\b/i.test(t);
    const hasRecliner = /\brecliner\b/i.test(t);
    const hasLShape = /\bl[- ]*shape\b/i.test(t);
    const hasUShape = /\bu[- ]*shape\b/i.test(t);
    const hasCorner = /\bcorner\b/i.test(t);
    const cornerConfiguration = t.match(/\b(\d+)\s*corner\s*(\d+)\b/i);
    const hasArmchair = /\barm\s*chair\b/i.test(t);

    return (alt) => {
      const a = n(alt);
      if (!a) return false;

      if (!hasFootstool && /\b(footstool|footsool|stool|pouffe|ottoman)\b/i.test(a)) return false;
      if (!hasSwivel && /\bswivel\b/i.test(a)) return false;
      if (!hasRecliner && /\brecliner\b/i.test(a)) return false;
      if (!hasLShape && /\bl[- ]*shape\b/i.test(a)) return false;
      if (!hasUShape && /\bu[- ]*shape\b/i.test(a)) return false;
      if (!hasCorner && /\bcorner\b/i.test(a)) return false;
      if (!hasArmchair && /\barm\s*chair\b/i.test(a)) return false;

      if (hasFootstool) return /\b(footstool|footsool|stool|pouffe|ottoman)\b/i.test(a);
      if (hasSwivel) return /\bswivel\b/i.test(a);
      if (hasRecliner) return /\brecliner\b/i.test(a);
      if (hasLShape) return /\bl[- ]*shape\b/i.test(a);
      if (hasUShape) return /\bu[- ]*shape\b/i.test(a);
      if (hasCorner) {
        if (cornerConfiguration) {
          const configuration = a.match(/\b(\d+)\s*corner\s*(\d+)\b/i);
          return Boolean(configuration && configuration[1] === cornerConfiguration[1] && configuration[2] === cornerConfiguration[2]);
        }
        return /\bcorner\b/i.test(a);
      }
      if (hasArmchair) return /\barm\s*chair\b/i.test(a);

      const m = t.match(/(\d+\+\d+|\d+)/);
      if (!m) return true;

      const nums = m[1];
      if (nums.includes("+")) {
        const combo = nums.replace("+", "\\s*\\+\\s*");
        const rx = new RegExp(`\\b${combo}\\b\\s*[- ]*\\s*seater\\b`, "i");
        return rx.test(a);
      }

      const k = nums;
      if (new RegExp(`\\+\\s*${k}\\b`).test(a)) return false;
      if (new RegExp(`\\b${k}\\s*\\+`).test(a)) return false;

      const rxSingle = new RegExp(`\\b${k}\\b\\s*[- ]*\\s*seater\\b`, "i");
      const rxNoSpace = new RegExp(`\\b${k}seater\\b`, "i");
      return rxSingle.test(a) || rxNoSpace.test(a);
    };
  }

  function isProductTypeValue(value) {
    const v = n(value);
    if (!v) return false;

    return /\b(footstool|footsool|stool|pouffe|ottoman|swivel|recliner|arm\s*chair|corner|l\s*shape|u\s*shape|\d+\s*\+\s*\d+\s*seater|\d+\s*seater)\b/i.test(v);
  }

  function selectedOptionValues(root) {
    const scope = root || document;
    const values = [];

    scope.querySelectorAll('input[type="radio"]:checked, select').forEach((control) => {
      const name = n((control.getAttribute("name") || "").replace(/^options\[/i, "").replace(/\]$/, ""));
      if (/^(color|colour)$/.test(name)) return;

      const value = control.value || "";
      if (value && !values.includes(value)) values.push(value);
    });

    return values;
  }

  const LEFT_FACING_RX = /\b(left|lh|lhf|lhs|laf|left[-_ ]*hand|left[-_ ]*hand[-_ ]*facing|left[-_ ]*facing|left[-_ ]*corner)\b/i;
  const RIGHT_FACING_RX = /\b(right|rh|rhf|rhs|raf|right[-_ ]*hand|right[-_ ]*hand[-_ ]*facing|right[-_ ]*facing|right[-_ ]*corner)\b/i;

  function styleMatcher(styleStr) {
    const s = n(styleStr);
    if (!s) return null;

    const isLeft = LEFT_FACING_RX.test(s);
    const isRight = RIGHT_FACING_RX.test(s);

    if (isLeft) {
      return (alt) => {
        const a = n(alt);
        return LEFT_FACING_RX.test(a) && !RIGHT_FACING_RX.test(a);
      };
    }

    if (isRight) {
      return (alt) => {
        const a = n(alt);
        return RIGHT_FACING_RX.test(a) && !LEFT_FACING_RX.test(a);
      };
    }

    return null;
  }

  function hasExplicitStyleMatch(slide, styleStr) {
    const s = n(styleStr);
    if (!s) return false;
    const a = metadataOf(slide).join(" ");
    if (!a) return false;

    const isLeft = LEFT_FACING_RX.test(s);
    const isRight = RIGHT_FACING_RX.test(s);

    if (isLeft) {
      return LEFT_FACING_RX.test(a) && !RIGHT_FACING_RX.test(a);
    }
    if (isRight) {
      return RIGHT_FACING_RX.test(a) && !LEFT_FACING_RX.test(a);
    }

    return false;
  }

  const COLOR_MODIFIERS = [
    "chocolate", "dark", "light", "medium", "deep", "soft", "pale", "bright",
    "chestnut", "tan", "golden", "mocha", "coffee", "biscuit", "camel", "taupe",
    "sand", "beige", "charcoal", "slate", "navy", "royal", "sky", "baby", "olive",
    "sage", "mint", "forest", "lime", "emerald", "wine", "rose", "blush", "coral",
    "mustard", "reddish", "bluish", "greenish", "yellowish"
  ];

  function colorOk(alt, color) {
    const a = n(alt);
    const c = n(color);
    if (!c) return true;
    if (!a) return false;

    if (a === c) return true;

    const aClean = a.replace(/[-_]/g, " ").replace(/\s*\b\d+\b\s*/g, " ").replace(/\s+/g, " ").trim();
    if (aClean === c) return true;

    // Uploaded colour names may join words in any letter case. Keep word
    // boundaries so Blue still cannot match Blueberry.
    const colorPattern = (value) => value.replace(/\s+/g, "").split("")
      .map((char) => char.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
      .join("\\s*");
    const esc = colorPattern(c);
    const reg = new RegExp(`\\b${esc}\\b`, "i");
    if (!reg.test(a)) return false;

    for (const mod of COLOR_MODIFIERS) {
      if (!c.includes(mod)) {
        const modRegex = new RegExp(`\\b${mod}\\s*${esc}\\b`, "i");
        if (modRegex.test(a)) {
          return false;
        }
      }
    }

    const colorOptInputs = document.querySelectorAll(
      'input[name="Color"], input[name="Colour"], input[name="colour"], input[name="COLOR"], select[name="Color"], select[name="Colour"], select[name="colour"], select[name="COLOR"], input[name="Color"], input[name="Colour"]'
    );
    for (const input of colorOptInputs) {
      const val = n(input.value);
      const compactVal = val.replace(/\s+/g, "");
      const compactColor = c.replace(/\s+/g, "");
      if (compactVal.length > compactColor.length && compactVal.includes(compactColor)) {
        const valEsc = colorPattern(val);
        if (new RegExp(`\\b${valEsc}\\b`, "i").test(a)) {
          return false;
        }
      }
    }

    return true;
  }

  function findBestMatchIndex(slides, color, sofaType, style) {
    const matches = [];

    slides.forEach((slide, idx) => {
      if (isExactMatch(slide, color, sofaType, style)) {
        matches.push({ idx: idx, slide: slide, seq: imageIndexOf(slide) });
      }
    });

    if (matches.length > 0) {
      matches.sort((a, b) => a.seq - b.seq);
      return matches[0].idx;
    }

    return -1;
  }

  function findBestMatchSlide(slides, color, sofaType, style) {
    const exactMatches = slides.filter((slide) => isExactMatch(slide, color, sofaType, style));
    if (exactMatches.length > 0) {
      const explicitStyleMatches = exactMatches.filter((slide) => hasExplicitStyleMatch(slide, style));
      if (explicitStyleMatches.length > 0) {
        explicitStyleMatches.sort((a, b) => imageIndexOf(a) - imageIndexOf(b));
        return explicitStyleMatches[0];
      }

      exactMatches.sort((a, b) => imageIndexOf(a) - imageIndexOf(b));
      return exactMatches[0];
    }

    const idx = findBestMatchIndex(slides, color, sofaType, style);
    return idx > -1 ? slides[idx] : null;
  }

  function isExactMatch(slide, color, sofaType, style) {
    const sources = metadataOf(slide);
    if (!sources.length || isSwatchImage(slide)) return false;

    const tMatch = typeMatcher(sofaType);
    const sMatch = styleMatcher(style);
    const filename = filenameOf(slide);
    // A filename with an explicit product type is authoritative. SEO alt
    // text often describes a combo as "3 seater and 2 seater".
    // Older corner uploads have generic filenames (Corner-Brown) and keep
    // the precise configuration (2 Corner 2) only in alt text.
    const typeSource = /\bcorner\b/.test(filename) && !/\b\d+\s*corner\s*\d+\b/.test(filename)
      ? (sources.find((value) => /\b\d+\s*corner\s*\d+\b/.test(value)) || filename)
      : filename;
    const filenameHasType = isProductTypeValue(typeSource);
    if (tMatch && filenameHasType && !tMatch(typeSource)) return false;

    return sources.some((value) =>
      (!tMatch || (filenameHasType ? tMatch(typeSource) : tMatch(value))) &&
      (!sMatch || sMatch(value)) &&
      colorOk(value, color)
    );
  }

  function filterMainSlides(mainSlides, color, sofaType, style) {
    let visibleCount = 0;

    mainSlides.forEach((slide) => {
      const ok = isExactMatch(slide, color, sofaType, style);
      show(slide, ok);
      if (ok) visibleCount++;
    });

    if (visibleCount === 0) {
      const genericSlide = mainSlides.find((slide) => {
        const sources = metadataOf(slide);
        return !sources.length || sources.every(isGenericAlt);
      });
      const best = genericSlide;
      mainSlides.forEach((slide) => show(slide, slide === best));
    }
  }

  function filterThumbs(thumbs, color, sofaType, style) {
    let visibleCount = 0;

    thumbs.forEach((slide) => {
      const ok = isExactMatch(slide, color, sofaType, style);
      show(slide, ok);
      if (ok) visibleCount++;
    });

    if (visibleCount === 0) {
      const genericThumb = thumbs.find((slide) => {
        const sources = metadataOf(slide);
        return !sources.length || sources.every(isGenericAlt);
      });
      const best = genericThumb;
      thumbs.forEach((slide) => show(slide, slide === best));
    }
  }

  function getPrimarySwiper(root) {
    const candidates = Array.from(
      (root || document).querySelectorAll(".swiper, .swiper-container")
    );

    for (const el of candidates) {
      if (el.swiper && el.closest(".product")) return el.swiper;
    }

    for (const el of candidates) {
      if (el.swiper) return el.swiper;
    }

    return null;
  }

  function getThumbSwiper(root) {
    const candidates = Array.from(
      (root || document).querySelectorAll(
        '[id*="GalleryThumbnails"] .swiper, [id*="GalleryThumbnails"] .swiper-container, .thumbnail-slider .swiper, .thumbnail-slider .swiper-container'
      )
    );

    for (const el of candidates) {
      if (el.swiper) return el.swiper;
    }

    return null;
  }

  function resetThumbStripToStart(root) {
    const thumbs = getThumbSlides(root);
    if (!thumbs.length) return;

    const firstVisibleIndex = thumbs.findIndex((slide) => {
      return slide.style.getPropertyValue("display") !== "none" && !slide.hidden;
    });

    thumbs.forEach((slide, index) => {
      const isVisible = slide.style.getPropertyValue("display") !== "none" && !slide.hidden;
      const isCurrent = isVisible && index === firstVisibleIndex;

      slide.classList.toggle("is-active", isCurrent);
      slide.classList.toggle("swiper-slide-thumb-active", isCurrent);
      slide.setAttribute("aria-current", isCurrent ? "true" : "false");
    });

    const thumbSwiper = getThumbSwiper(root);
    if (thumbSwiper) {
      try {
        thumbSwiper.updateSlides();
      } catch (e) {}

      try {
        thumbSwiper.update();
      } catch (e) {}

      try {
        thumbSwiper.slideTo(0, 0, false);
      } catch (e) {}

      try {
        thumbSwiper.setTranslate(0);
      } catch (e) {}

      try {
        thumbSwiper.translate = 0;
      } catch (e) {}

      try {
        if (thumbSwiper.wrapperEl) {
          thumbSwiper.wrapperEl.style.transform = "translate3d(0px, 0px, 0px)";
          thumbSwiper.wrapperEl.style.transitionDuration = "0ms";
        }
      } catch (e) {}
    }

    const wrapper =
      document.querySelector('[id*="GalleryThumbnails"] .swiper-wrapper') ||
      document.querySelector(".thumbnail-slider .swiper-wrapper");

    if (wrapper) {
      wrapper.style.transform = "translate3d(0px, 0px, 0px)";
      wrapper.style.transitionDuration = "0ms";
    }
  }

  function slideToVisibleIndex(root, absoluteIndex) {
    const swiper = getPrimarySwiper(root);
    if (!swiper) return;

    try {
      swiper.update();
      swiper.slideTo(absoluteIndex >= 0 ? absoluteIndex : 0, 0);
    } catch (e) {}
  }

  function findMatchingThumbBySlide(root, targetSlide) {
    if (!targetSlide) return null;

    const thumbs = getThumbSlides(root);
    const targetAlt = altOf(targetSlide);
    const targetSrc = srcOf(targetSlide);
    const targetMediaId = mediaIdOf(targetSlide);

    let thumb =
      thumbs.find((t) => {
        const thumbMediaId = mediaIdOf(t);
        return targetMediaId && thumbMediaId && targetMediaId === thumbMediaId;
      }) ||
      thumbs.find((t) => targetAlt && altOf(t) === targetAlt) ||
      thumbs.find((t) => targetSrc && srcOf(t) === targetSrc);

    return thumb || null;
  }

  function activateSlideByMatch(root, targetSlide) {
    if (!targetSlide) return;

    if (root && typeof root.closest === "function" && root.closest("quick-add-modal")) {
      if (targetSlide.parentElement) {
        targetSlide.parentElement.prepend(targetSlide);
      }
    }

    const mainSlides = getMainSlides(root);
    const targetAlt = altOf(targetSlide);
    const targetSrc = srcOf(targetSlide);
    const targetMediaId = mediaIdOf(targetSlide);

    let absoluteIndex = mainSlides.findIndex((slide) => {
      const slideMediaId = mediaIdOf(slide);
      if (targetMediaId && slideMediaId && targetMediaId === slideMediaId) return true;
      if (targetAlt && altOf(slide) === targetAlt) return true;
      if (targetSrc && srcOf(slide) === targetSrc) return true;
      return false;
    });

    if (absoluteIndex < 0) absoluteIndex = 0;

    slideToVisibleIndex(root, absoluteIndex);

    const thumb = findMatchingThumbBySlide(root, targetSlide);
    if (thumb) {
      const btn =
        thumb.querySelector("button") ||
        thumb.querySelector("[data-target]") ||
        thumb.querySelector("img") ||
        thumb.querySelector("a");

      if (btn && typeof btn.click === "function") {
        btn.click();
      }
    }

    setTimeout(() => {
      slideToVisibleIndex(root, absoluteIndex);
      resetThumbStripToStart(root);
    }, 40);

    setTimeout(() => {
      resetThumbStripToStart(root);
    }, 120);

    setTimeout(() => {
      resetThumbStripToStart(root);
    }, 220);
  }

  function syncMainImage(root, revealAfter = true) {
    const color = getOpt(["Color", "Colour", "colour", "COLOR"], root);
    let sofaType = getOpt([
      "Sofa Style", "SofaStyle", "Sofa Type", "SofaType", "Product Type",
      "Sofa Size", "Type", "Size", "Seater", "Configuration"
    ], root);
    let style = getOpt(["Style", "style", "Facing", "Hand", "Orientation"], root);

    /*
     * Several products store Footstool/Swivel/Seater choices under an option
     * named "Style" (or another custom name). Detect by the selected value so
     * those choices still drive strict product-type media filtering.
     */
    if (!sofaType || !isProductTypeValue(sofaType)) {
      const detectedType = selectedOptionValues(root).find(isProductTypeValue);
      if (detectedType) sofaType = detectedType;
    }

    if (style && isProductTypeValue(style) && !LEFT_FACING_RX.test(n(style)) && !RIGHT_FACING_RX.test(n(style))) {
      style = "";
    }

    const mainSlides = getMainSlides(root);
    const thumbSlides = getThumbSlides(root);

    if (!mainSlides.length) {
      if (revealAfter) unlockGallery(root);
      return;
    }

    const targetSlide = findBestMatchSlide(mainSlides, color, sofaType, style);

    if (targetSlide) {
      show(targetSlide, true);
      activateSlideByMatch(root, targetSlide);
    }

    filterMainSlides(mainSlides, color, sofaType, style);
    filterThumbs(thumbSlides, color, sofaType, style);

    const reapplyStrictFilter = () => {
      filterMainSlides(getMainSlides(root), color, sofaType, style);
      filterThumbs(getThumbSlides(root), color, sofaType, style);
    };

    setTimeout(reapplyStrictFilter, 40);

    setTimeout(() => {
      if (targetSlide) activateSlideByMatch(root, targetSlide);
      reapplyStrictFilter();
      resetThumbStripToStart(root);
      if (revealAfter) unlockGallery(root);
    }, 120);
  }

  function initVariantRadios(root) {
    if (!root) return;

    const fieldsets = root.querySelectorAll("fieldset");

    function setActiveForFieldset(fieldset) {
      const inputs = fieldset.querySelectorAll('input[type="radio"]');

      inputs.forEach((input) => {
        const label = fieldset.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        label.classList.toggle("is-active", input.checked);
      });
    }

    function updateLegend(fieldset) {
      const legend = fieldset.querySelector("legend.form__label");
      if (!legend) return;

      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (!checked) return;

      const optionName = checked.name || "";
      const value = checked.value || "";

      legend.innerHTML = "<strong>" + optionName + ":</strong> " + value;
    }

    function refreshAll() {
      fieldsets.forEach((fs) => {
        setActiveForFieldset(fs);
        updateLegend(fs);
      });
    }

    refreshAll();

    root.addEventListener("change", function (e) {
      const input = e.target;
      if (!input || input.type !== "radio") return;

      const fieldset = input.closest("fieldset");
      if (!fieldset) return;

      setActiveForFieldset(fieldset);
      updateLegend(fieldset);

      const productRoot = root.closest(".product") || root.closest("section") || document;
      lockGallery(productRoot);

      setTimeout(() => {
        syncMainImage(productRoot, true);
      }, 30);
    });

    root.addEventListener("click", function (e) {
      const label = e.target.closest("label");
      if (!label) return;

      const forId = label.getAttribute("for");
      if (!forId) return;

      const input = root.querySelector("#" + safeEscape(forId));
      if (!input) return;

      const productRoot = root.closest(".product") || root.closest("section") || document;
      lockGallery(productRoot);

      setTimeout(() => {
        refreshAll();
        syncMainImage(productRoot, true);
      }, 0);
    });
  }

  function attachGlobalListeners() {
    document.addEventListener("change", function (e) {
      const t = e.target;
      if (!t) return;

      const isRadio = t.matches('input[type="radio"]');
      const isSelect = t.matches("select");
      if (!isRadio && !isSelect) return;

      const name = n((t.getAttribute("name") || "").replace(/^options\[/i, "").replace(/\]$/, ""));
      if (
        name === "color" ||
        name === "colour" ||
        name === "style" ||
        name === "facing" ||
        name === "hand" ||
        name === "orientation" ||
        name === "sofa type" ||
        name === "sofatype" ||
        name === "sofa style" ||
        name === "sofastyle" ||
        name === "product type" ||
        name === "sofa size" ||
        name === "configuration" ||
        name === "type" ||
        name === "size" ||
        name === "seater" ||
        isProductTypeValue(t.value)
      ) {
        const productRoot = t.closest(".product") || t.closest("section") || document;
        lockGallery(productRoot);
        setTimeout(() => {
          syncMainImage(productRoot, true);
        }, 30);
      }
    });

    document.addEventListener("variant:change", function (e) {
      const t = e.target;
      const productRoot = t ? (t.closest(".product") || t.closest("section") || document) : document;
      lockGallery(productRoot);
      setTimeout(() => {
        syncMainImage(productRoot, true);
      }, 50);
    });

  }

  function injectPreventFlashCSS() {
    /* Disabled: prevent flash style injection removed to eliminate blinking */
  }

  function initAll() {
    document.querySelectorAll("variant-radios").forEach(initVariantRadios);
    attachGlobalListeners();
    document.querySelectorAll(".product, section[id^='MainProduct-']").forEach((el) => {
      syncMainImage(el, false);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
